/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import Vue from 'vue';
import Vuex, { Plugin, StoreOptions } from 'vuex';
import Axios from 'axios';
import { RootState } from './types';
import { price } from './price';
import { dashboard } from './dashboard';
import { locations } from './location';
import { paymentMethods } from './methods';
import { donation } from './donation';
import { news } from './news';
import { textPage } from './textpage';
import { game } from './game';
import { landingPage } from './landingpage';
import { product } from './product';
import { order } from './order';
import { defaultRequestConfig } from '../config/network';
import { cloud } from './cloud';
import { payment } from './payment';
import { auth } from './auth';

Vue.use(Vuex);

const options: StoreOptions<RootState> = {
  state: {
    version: '1.0.0',
    $http: Axios.create(defaultRequestConfig),
  },
  modules: {
    auth,
    landingPage,
    cloud,
    price,
    dashboard,
    locations,
    product,
    order,
    paymentMethods,
    donation,
    game,
    news,
    textPage,
    payment,
  },
};

export const store = new Vuex.Store<RootState>(options);
export const useStore = () => store;
